"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Space = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
var components_1 = require("../../components");
var space_details_layout_1 = require("../../components/entities/space-details-layout");
exports.Space = {
  name: 'Space',
  useSlices: true,
  useSites: true,
  useConversation: true,
  useConnections: true,
  useModerators: true,
  includeInSearch: true,
  icon: function () {
    return components_1.Icons.Entities.Team;
  },
  components: {
    details: space_details_layout_1.SpaceDetailsLayout
  },
  table: {},
  filters: {
    fields: {
      types: {
        entityTypeName: 'SpaceType'
      }
    }
  },
  list: {
    hasSearch: true,
    resultsVariant: 'grid',
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      description { id text plain plainTruncated: plain(truncate: { words: 25 }) } \n      badge\n      typeLabel\n    "], ["\n      description { id text plain plainTruncated: plain(truncate: { words: 25 }) } \n      badge\n      typeLabel\n    "])))
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      agenda { id text }\n      description { id text\n        linkEmbeds { ", " _label url }\n        linkRichEmbeds { ", " _label url }\n      }\n      organisationMemberships { ...EntityValueFields role { ...EntityValueFields } badge organisation { ...EntityValueFields } }\n      links { ...EntityValueFields url }\n      fileAssets { ...FileAssetValueFields }\n      imageAssets {\n        id name image { id url url2x }\n      }\n      activities {\n        id name slug due type { id name slug } status { id name slug } team { id name slug description { id text } } description { id text html } tasks { id name slug completed due description { id text html } } links { id name slug url types { id name slug } type { id name slug } image { id url } } files { ...FileAssetValueFields } documents { id name slug type { id name slug } }\n      }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      memberships {\n        ...EntityValueFields\n        badge\n        role { ...EntityValueFields }\n        person { ...EntityValueFields }\n      }\n    "], ["\n      agenda { id text }\n      description { id text\n        linkEmbeds { ", " _label url }\n        linkRichEmbeds { ", " _label url }\n      }\n      organisationMemberships { ...EntityValueFields role { ...EntityValueFields } badge organisation { ...EntityValueFields } }\n      links { ...EntityValueFields url }\n      fileAssets { ...FileAssetValueFields }\n      imageAssets {\n        id name image { id url url2x }\n      }\n      activities {\n        id name slug due type { id name slug } status { id name slug } team { id name slug description { id text } } description { id text html } tasks { id name slug completed due description { id text html } } links { id name slug url types { id name slug } type { id name slug } image { id url } } files { ...FileAssetValueFields } documents { id name slug type { id name slug } }\n      }\n      challenges { ...EntityValueFields }\n      keyIssues { ...EntityValueFields }\n      trends { ...EntityValueFields }\n      topics { ...EntityValueFields }\n      subTopics { ...EntityValueFields }\n\n      memberships {\n        ...EntityValueFields\n        badge\n        role { ...EntityValueFields }\n        person { ...EntityValueFields }\n      }\n    "])), graphql_1.ENTITY_VALUE_FIELDS, graphql_1.ENTITY_VALUE_FIELDS)
  },
  autoRoutes: ['create', 'update', 'list', 'details'],
  form: {
    bufferAtEnd: 300,
    fieldSets: [{
      name: 'overview',
      label: 'Overview'
    }, {
      name: 'membership',
      label: 'Membership'
    }, {
      name: 'activities',
      label: 'Activities'
    }, {
      name: 'related',
      label: 'Related'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      types: {
        type: 'linkedMultiple',
        entityTypeName: 'SpaceType',
        label: "Types",
        description: "What type of {{SPACE}} is this?"
      },
      statuses: {
        type: 'linkedMultiple',
        entityTypeName: 'SpaceStatus',
        label: "Status",
        description: "Assign one or more {{SPACE_STATUSES}} to this {{SPACE}}."
      },
      banners: {
        type: 'linkedMultiple',
        entityTypeName: 'Banner'
      },
      description: {
        type: 'longText'
      },
      summary: {
        type: 'longText'
      },
      agenda: {
        type: 'longText',
        description: "Does this {{SPACE}} have a specific agenda?"
      },
      activities: {
        type: 'linkedTable',
        fieldSet: 'activities',
        entityTypeName: 'Workstream',
        description: "Does this {{SPACE}} have any associated {{WORKSTREAMS}}?"
      },
      fileAssets: {
        type: 'linkedMultiple',
        entityTypeName: 'FileAsset',
        description: "Does this {{SPACE}} have any associated {{FILE_ASSETS}}?"
      },
      podcasts: {
        type: 'linkedMultiple',
        entityTypeName: 'Podcast',
        description: "Does this {{SPACE}} have any associated {{PODCASTS}}?"
      },
      imageAssets: {
        type: 'linkedMultiple',
        entityTypeName: 'ImageAsset',
        description: "Does this {{SPACE}} have any {{IMAGE_ASSETS}}?"
      },
      links: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        description: "Does this {{SPACE}} have any relevant {{LINKS}}?"
      },
      memberships: {
        type: 'linkedTable',
        fieldSet: 'membership',
        entityTypeName: 'SpaceMembership',
        label: "{{PEOPLE}}",
        description: "Who are the people in this {{SPACE}}, and what are their {{SPACE_ROLES}}?"
      },
      organisationMemberships: {
        type: 'linkedTable',
        fieldSet: 'membership',
        entityTypeName: 'OrganisationSpaceMembership',
        label: "{{ORGANISATIONS}}",
        description: "Do any {{ORGANISATIONS}} have roles in this {{SPACE}}?"
      },
      relatedChallenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        description: "Does this {{SPACE}} have any related {{CHALLENGES}}?",
        fieldSet: 'related'
      },
      relatedCitations: {
        type: 'linkedMultiple',
        entityTypeName: 'Citation',
        description: "Does this {{SPACE}} have any related {{CITATIONS}}?",
        fieldSet: 'related'
      },
      relatedCourses: {
        type: 'linkedMultiple',
        entityTypeName: 'Course',
        description: "Does this {{SPACE}} have any related {{COURSES}}?",
        fieldSet: 'related'
      },
      relatedEconomies: {
        type: 'linkedMultiple',
        entityTypeName: 'Economy',
        description: "Does this {{SPACE}} have any related {{ECONOMIES}}?",
        fieldSet: 'related'
      },
      relatedEvents: {
        type: 'linkedMultiple',
        entityTypeName: 'Event',
        description: "Does this {{SPACE}} have any related {{EVENTS}}?",
        fieldSet: 'related'
      },
      relatedFeedEntries: {
        type: 'linkedMultiple',
        entityTypeName: 'FeedEntry',
        description: "Does this {{SPACE}} have any related {{FEED_ENTRIES}}?",
        fieldSet: 'related'
      },
      relatedGlobalRegions: {
        type: 'linkedMultiple',
        entityTypeName: 'GlobalRegion',
        description: "Does this {{SPACE}} have any related {{GLOBAL_REGIONS}}?",
        fieldSet: 'related'
      },
      relatedIndustries: {
        type: 'linkedMultiple',
        entityTypeName: 'Industry',
        description: "Does this {{SPACE}} have any related {{INDUSTRIES}}?",
        fieldSet: 'related'
      },
      relatedKeyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        description: "Does this {{SPACE}} have any related {{KEY_ISSUES}}?",
        fieldSet: 'related'
      },
      relatedLessons: {
        type: 'linkedMultiple',
        entityTypeName: 'Lesson',
        description: "Does this {{SPACE}} have any related {{LESSONS}}?",
        fieldSet: 'related'
      },
      relatedLocations: {
        type: 'linkedMultiple',
        entityTypeName: 'Location',
        description: "Does this {{SPACE}} have any related {{LOCATIONS}}?",
        fieldSet: 'related'
      },
      relatedOrganisations: {
        type: 'linkedMultiple',
        entityTypeName: 'Organisation',
        description: "Does this {{SPACE}} have any related {{ORGANISATIONS}}?",
        fieldSet: 'related'
      },
      relatedPages: {
        type: 'linkedMultiple',
        entityTypeName: 'Page',
        description: "Does this {{SPACE}} have any related {{PAGES}}?",
        fieldSet: 'related'
      },
      relatedPeople: {
        type: 'linkedMultiple',
        entityTypeName: 'Person',
        description: "Does this {{SPACE}} have any other related {{PEOPLE}}?",
        fieldSet: 'related'
      },
      relatedPosts: {
        type: 'linkedMultiple',
        entityTypeName: 'Post',
        description: "Does this {{SPACE}} have any related {{POSTS}}?",
        fieldSet: 'related'
      },
      relatedProducts: {
        type: 'linkedMultiple',
        entityTypeName: 'Product',
        description: "Does this {{SPACE}} have any related {{PRODUCTS}}?",
        fieldSet: 'related'
      },
      relatedProjects: {
        type: 'linkedMultiple',
        entityTypeName: 'Project',
        description: "Does this {{SPACE}} have any related {{PROJECTS}}?",
        fieldSet: 'related'
      },
      relatedSdgs: {
        type: 'linkedMultiple',
        entityTypeName: 'Sdg',
        description: "Does this {{SPACE}} have any related {{SDGS}}?",
        fieldSet: 'related'
      },
      relatedSubTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        description: "Does this {{SPACE}} have any related {{SUB_TOPICS}}?",
        fieldSet: 'related'
      },
      relatedTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        description: "Does this {{SPACE}} have any related {{TOPICS}}?",
        fieldSet: 'related'
      },
      relatedTrends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        description: "Does this {{SPACE}} have any related {{TRENDS}}?",
        fieldSet: 'related'
      }
    })
  }
};
var templateObject_1, templateObject_2;